import type { ContentStatus, PlaybookStatus } from '@doneverse/shared'
import { Badge } from '@/components/ui/badge'

/**
 * One rendering of a content lifecycle state, so the list, the editor header
 * and the publish tab cannot describe the same record differently.
 *
 * `playbook_status` and `content_status` are separate database enums over the
 * same three values — different tables, independently evolvable — but they mean
 * the same thing to an author, so they render the same badge.
 */
type LifecycleStatus = PlaybookStatus | ContentStatus

const STATUS_META: Record<LifecycleStatus, { label: string; variant: 'default' | 'secondary' | 'outline' }> =
  {
    // `default` is the filled/primary badge — reserved for the one state that
    // means "founders can see this right now".
    published: { label: 'Published', variant: 'default' },
    draft: { label: 'Draft', variant: 'secondary' },
    archived: { label: 'Archived', variant: 'outline' },
  }

export function PublishStatusBadge({ status }: { status: LifecycleStatus }) {
  const meta = STATUS_META[status] ?? STATUS_META.draft
  return (
    <Badge variant={meta.variant} className="text-xs">
      {meta.label}
    </Badge>
  )
}
